import axios from "api/axiosInstance";
import apiList from "actions/apiList";

export const MAINTENANCE_EVENT = "redington:maintenance-lock";

let interceptorRegistered = false;

const isMaintenancePayload = (data) =>
  Boolean(
    data &&
      (data.type === "maintenance" ||
        (data.enabled === true && data.allowed === false))
  );

export function notifyMaintenanceLock(detail = {}) {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(MAINTENANCE_EVENT, {
      detail: {
        enabled: true,
        allowed: false,
        ...detail,
      },
    })
  );
}

export function registerMaintenanceInterceptor() {
  if (interceptorRegistered) {
    return;
  }
  interceptorRegistered = true;

  axios.interceptors.response.use(
    (response) => {
      if (isMaintenancePayload(response?.data)) {
        notifyMaintenanceLock(response.data);
      }
      return response;
    },
    (error) => {
      const status = error?.response?.status;
      const data = error?.response?.data;
      if (status === 503 && isMaintenancePayload(data)) {
        notifyMaintenanceLock(data);
      }
      return Promise.reject(error);
    }
  );
}

registerMaintenanceInterceptor();

export async function fetchMaintenanceStatus() {
  const headers = {};
  if (process.env.REACT_APP_X_PUBLISHER_API_KEY) {
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;
  }

  try {
    const response = await axios.get(apiList.maintenanceStatus, {
      headers,
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 503,
    });

    if (response.status === 503 || isMaintenancePayload(response?.data)) {
      const lockedStatus = {
        enabled: true,
        allowed: false,
        message: response?.data?.message || "",
        marquee: response?.data?.marquee || null,
      };
      notifyMaintenanceLock(response?.data || lockedStatus);
      return lockedStatus;
    }

    return {
      enabled: Boolean(response?.data?.enabled),
      allowed: response?.data?.allowed !== false,
      message: response?.data?.message || "",
      marquee: response?.data?.marquee || null,
    };
  } catch (error) {
    // If any store call already reported maintenance, prefer that.
    console.warn(
      "Maintenance status check failed; storefront will rely on API 503 interceptor.",
      error
    );
    return {
      enabled: false,
      allowed: true,
      message: "",
      marquee: null,
    };
  }
}
